import CheckIcon from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

export default function VoidRebillCompletionSummary({
  originalSettlementId,
  rebillSettlementId,
}: {
  originalSettlementId: string;
  rebillSettlementId: string;
}) {
  return (
    <Box>
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          color: 'text.secondary',
          mb: 3,
        }}
      >
        {t('approvals.driver_pay.settlements.void_rebill_completion.description')}
      </Typography>
      <Box sx={{ mb: 3 }}>
        <MessageRow
          message={t(
            'approvals.driver_pay.settlements.void_rebill_completion.original_voided_message',
            {
              originalSettlementId,
            },
          )}
        />

        <MessageRow
          message={t(
            'approvals.driver_pay.settlements.void_rebill_completion.rebill_created_message',
            {
              rebillSettlementId,
            },
          )}
        />

        <MessageRow
          message={t(
            'approvals.driver_pay.settlements.void_rebill_completion.add_ons_generated_message',
          )}
        />
      </Box>
    </Box>
  );
}

const MessageRow = ({ message }: { message: string }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <CheckIcon sx={{ color: 'success.main', mr: 1, fontSize: 36 }} />
      <Typography variant="body1">{message}</Typography>
    </Box>
  );
};
